import { FloatingFormItem } from '@/components/_common';
import {
  TaxeIcmsCsosnSelect,
  TaxeIcmsCstSelect,
} from '@/components/_common/TaxesSelect';
import { TaxRegimeEnum } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';

interface CommonProps {
  name: (string | number)[];
  disabled: boolean;
}

export const renderIcmsCstSelect = (
  taxRegime: TaxRegimeEnum | undefined,
  invoiceType: string,
) => {
  const commonProps: CommonProps = {
    name: [invoiceType, 'icmsCstDefault'],
    disabled: !taxRegime,
  };

  if (
    taxRegime === TaxRegimeEnum.normal ||
    taxRegime === TaxRegimeEnum.simpleNationalExcessSublimitGrossRevenue
  ) {
    return (
      <FloatingFormItem {...commonProps} label="ICMS CST">
        <TaxeIcmsCstSelect />
      </FloatingFormItem>
    );
  }

  if (taxRegime === TaxRegimeEnum.simplesNationalMei) {
    return (
      <FloatingFormItem {...commonProps} label="CSOSN">
        <TaxeIcmsCsosnSelect isMei />
      </FloatingFormItem>
    );
  }

  if (taxRegime === TaxRegimeEnum.simple) {
    return (
      <FloatingFormItem {...commonProps} label="CSOSN">
        <TaxeIcmsCsosnSelect />
      </FloatingFormItem>
    );
  }

  return null;
};
